import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import { keyframes } from 'styled-components';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const SHIMMER_ANIMATION = keyframes(["0%{background-position:-468px 0;}100%{background-position:468px 0;}"]);
const getColors = (theme, use) => use === 'on-dark' ? {
  background: theme.color['fill-field-disabled'],
  highlight: theme.color['fill-field-default']
} : {
  background: theme.color['fill-primary-disabled'],
  highlight: theme.color['fill-surface-default']
};

// Borrowed from data-quality-ui
const StyledSkeleton = styled.span.withConfig({
  displayName: "Skeleton__StyledSkeleton",
  componentId: "sc-132fadr-0"
})(["display:inline-block;width:100%;height:100%;border-radius:inherit;background:", ";background-repeat:no-repeat;background-size:800px 200px;background-image:linear-gradient( to right,", " 0%,", " 20%,", " 40% );animation:", " 1s linear 0s infinite forwards;"], ({
  theme,
  use
}) => getColors(theme, use).background, ({
  theme,
  use
}) => getColors(theme, use).background, ({
  theme,
  use
}) => getColors(theme, use).highlight, ({
  theme,
  use
}) => getColors(theme, use).background, SHIMMER_ANIMATION);
const Skeleton = _ref => {
  let {
      use
    } = _ref,
    viewProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    role: "status",
    "data-loading": "true",
    inlineSize: "100%",
    blockSize: "16px"
  }, viewProps, {
    children: /*#__PURE__*/_jsx(StyledSkeleton, {
      use: use
    })
  }));
};
export default Skeleton;